import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useAccelContext } from '../../contexts/AccelContext/AccelContext';

interface ClosedBook {
  month: string;
  year: number;
  closedDate: string;
  revenue: number;
  expenses: number;
  profit: number;
}

const ClosedBooksMonthly: React.FC = () => {
  const { theme } = useAccelContext();
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  // Mock data - replace this with actual data from your API
  const closedBooks: ClosedBook[] = [
    { month: 'January', year: 2024, closedDate: '2024-02-05', revenue: 50000, expenses: 30000, profit: 20000 },
    { month: 'February', year: 2024, closedDate: '2024-03-07', revenue: 55000, expenses: 32000, profit: 23000 },
    { month: 'March', year: 2024, closedDate: '2024-04-06', revenue: 60000, expenses: 35000, profit: 25000 },
    // Add more months as needed
  ];

  const years = Array.from(new Set(closedBooks.map(book => book.year))).sort((a, b) => b - a);

  const filteredBooks = closedBooks.filter(book => book.year === selectedYear);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" component="h2" color={theme?.text?.hex}>
          Closed Books by Month
        </Typography>
        <FormControl variant="outlined" size="small">
          <InputLabel>Year</InputLabel>
          <Select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value as number)}
            label="Year"
          >
            {years.map(year => (
              <MenuItem key={year} value={year}>{year}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Month</TableCell>
              <TableCell>Closed Date</TableCell>
              <TableCell align="right">Revenue</TableCell>
              <TableCell align="right">Expenses</TableCell>
              <TableCell align="right">Profit</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBooks.map((book) => (
              <TableRow key={`${book.year}-${book.month}`}>
                <TableCell>{book.month}</TableCell>
                <TableCell>{book.closedDate}</TableCell>
                <TableCell align="right">${book.revenue.toLocaleString()}</TableCell>
                <TableCell align="right">${book.expenses.toLocaleString()}</TableCell>
                <TableCell align="right">${book.profit.toLocaleString()}</TableCell>
                <TableCell align="right">
                  <Button variant="outlined" size="small">View Details</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ClosedBooksMonthly;